import { useTranslations } from '@vocab/react';
import { Button, Stack, Text } from 'braid-design-system';

import type { AnalyticsVerificationsWidgetCallToAction } from 'src/modules/analytics/types';

import translations from './.vocab';

interface NudgeProps {
  buttonOnClick: () => void;
  analyticsOnClick: (props: {
    callToAction: AnalyticsVerificationsWidgetCallToAction;
  }) => void;
}

export const OpenDetailsNudge = ({
  analyticsOnClick,
  buttonOnClick,
}: NudgeProps) => {
  const { t } = useTranslations(translations);

  const CALL_TO_ACTION: AnalyticsVerificationsWidgetCallToAction =
    'add_verifications';
  const onClick = () => {
    analyticsOnClick({ callToAction: CALL_TO_ACTION });
    buttonOnClick();
  };

  return (
    <Stack space="medium">
      <Text tone="secondary">
        {t('Profiles with verifications are more likely to be selected.')}
      </Text>
      <Button onClick={onClick}>{t('Get verified')}</Button>
    </Stack>
  );
};
